<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item label="日期" prop="date">
							<el-date-picker type="daterange" v-model="formInline.date" :disabled-date="disabledDate"
								value-format="YYYY-MM-DD"></el-date-picker>
						</el-form-item>
						<el-form-item label="班级" prop="client_id">
							<el-cascader :options="clientData" placeholder="班级"
								v-model="formInline.client_id"></el-cascader>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetFun" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary" v-if="$store.state.pageAction.indexOf('message.add')> -1">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="考勤日期" prop="day" width="160"></el-table-column>
				<el-table-column label="班级" prop="client_name" width="160"></el-table-column>
				<el-table-column label="总人数" prop="user_count" width="160"></el-table-column>
				<el-table-column label="签到总人数" prop="start_count" width="160"></el-table-column>
				<el-table-column label="签到缺勤" width="180">
					<template #default="{ row }">
						{{ Number(row.user_count  || 0) - Number(row.start_count  || 0) }}
					</template>
				</el-table-column>
				<el-table-column label="签退总人数" prop="end_count" width="160"></el-table-column>
				<el-table-column label="签退缺勤" width="180">
					<template #default="{ row }">
						{{ Number(row.user_count  || 0) - Number(row.end_count  || 0) }}
					</template>
				</el-table-column>
				<el-table-column label="总缺勤人数" prop="user_count_absence" width="160"></el-table-column>
			</el-table>

			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 100]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</el-card>
	</div>
</template>
<script>
	import attendance from "../../model/attendance";
	import clients from "@/model/client";

	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					title: "",
					client_id: [],
					data: [],
					page: 1,
					size: 10
				},
				resetform: {
					uid: "",
					title: "",
					password: ""
				},
				listCount: 0,
				appData: [],
				clientData: [],
				addPop: false,
				addForm: {
					status: "",
					title: "",
					content: "",
					comment: "",
					approve_uid: "",
					approve_name: ""
				},
				statusOpts: [{
					label: '通过',
					value: 2
				}, {
					label: '拒绝',
					value: 3
				}],
				roleOpts: [],
				rules: {
					approve_status: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					comment: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			await this.clientList();
		},
		methods: {
			resetFun() {
				this.formInline.title = ''
				this.formInline.client_id = []
				this.formInline.date = []
				this.loadData()
			},
			async loadData() {
				const ret = await attendance.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
					this.formInline.date = ret.data.date;
				}
			},
			async clientList() {
				const ret = await clients.list();
				if (ret.code === 200) {
					this.clientData = this.handleClientTree(ret.data)
				}
			},
			handleClientTree(data) {
				if (data.length === 0) {
					return []
				}
				let options = []
				data.forEach(item => {
					options.push({
						value: item.id,
						label: item.name
					})
					if (item.children.length > 0) {
						options.push({
							value: item.id,
							label: item.name,
							children: this.handleClientTree(item.children)
						})
					}
				})
				return options
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						status: "",
						comment: "",
					}
				})
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>